export function formatFileSize(bytes: number): string {
  const megabytes: number = bytes / (1024 * 1024);
  return megabytes.toFixed() + " MB";
}
